export default __webpack_public_path__ + "static/media/green-chrome-outline.55e8304e.svg";